import { render } from "./wokerDetail6.vue?vue&type=template&id=1702439d&scoped=true"
import script from "./wokerDetail6.vue?vue&type=script&lang=js"
export * from "./wokerDetail6.vue?vue&type=script&lang=js"

import "./wokerDetail6.vue?vue&type=style&index=0&id=1702439d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1702439d"]])

export default __exports__